"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("../../../utils/styles");

var _overrides = require("../../../utils/overrides");

var _Icon = _interopRequireDefault(require("../Icon"));

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'CarouselPreviousArrow');

function PreviousArrow(_ref) {
  var className = _ref.className,
      style = _ref.style,
      onClick = _ref.onClick;
  var classes = (0, _overrides.useClasses)(useStyles);
  var rootClass = (0, _classnames.default)(className, classes.arrow, classes.arrowLeft);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClass,
    style: style
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "chevron",
    onClick: onClick
  }));
}

process.env.NODE_ENV !== "production" ? PreviousArrow.propTypes = {
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  onClick: _propTypes.default.func
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(PreviousArrow);

exports.default = _default;